import React from 'react'

export default (props) => (
    <button type={'button'} className={props.className}
            data-testid={props.testId || 'scheduler-next-button'}
            onClick={props.next}
            disabled={props.hasOwnProperty('disabled') && props.disabled}>
        {props.hasOwnProperty('children') && props.children && <div>{props.children}</div>}
        {(!props.hasOwnProperty('children') || !props.children) && <div>
            Next</div>}
    </button>
)